<template>
  <div class="box">
    <breadcrumb :breadcrumb="breadcrumb"></breadcrumb>
    <template v-if="$menuList['SIS-Products-ProductInfo-Add']">
      <div class="card">
        <batch-add-card :config="add" ></batch-add-card>
      </div>
    </template>
    <template v-if="$menuList['SIS-Products-ProductInfo-Edit']">
      <batch-edit-card :config="edit"></batch-edit-card>
    </template>
  </div>
</template>
<script>
import breadcrumb from "../../components/breadcrumb";
import batchAddCard from "../../components/batchAddCard";
import batchEditCard from "../../components/batchEditCard";

export default {
  components: {
    breadcrumb,
    batchAddCard,
    batchEditCard,
  },
  data() {
    return {
      breadcrumb: {
        title: this.language("addEditProduct.breadcrumbTitle"),
        list: [
          {
            name: this.language("addEditProduct.breadcrumbList_1"),
          },
          {
            name: this.language("addEditProduct.breadcrumbList_2"),
          },
        ],
      },
      add: {
        fileType: {
          1: [".xlsx"],
          2: [".zip"],
        },
        type: "ossPage",
        form: {
          shopNum: this.$shopData.shopNum,
          mchShopNum: this.$shopData.shopNum,
        },
        title: this.language("addEditProduct.step1Title"),
        setp1: {
          title: this.language("addEditProduct.step") + "1",
          temUrl: "/admin/merchant/upload/downloadTemplateFile",
          text: this.language("addEditProduct.addStep1Text"),
          button: this.language("addEditProduct.download"),
        },
        setp2: {
          title: this.language("addEditProduct.step") + "2",
          text: this.language("addEditProduct.addStep2Text"),
        },
        setp3: {
          title: this.language("addEditProduct.step") + "3",
          text: this.language("addEditProduct.addStep3Text"),
        },
        stepButton: this.language("addEditProduct.stepButton"),
        uploaderUrl: "admin/merchant/upload/saveProductsBatch",
      },

      edit: {
        fileType: {
          1: [".xlsx"],
          2: [".zip"],
        },
        form: {
          shopNum: this.$shopData.shopNum,
          mchShopNum: this.$shopData.shopNum,
        },
        title: this.language("addEditProduct.step2Title"),
        setp1: {
          title: this.language("addEditProduct.step") + "1",
          text: this.language("addEditProduct.editStep1Text"),
        },
        setp2: {
          title: this.language("addEditProduct.step") + "2",
          text: this.language("addEditProduct.editStep2Text"),
        },
        setp3: {
          title: this.language("addEditProduct.step") + "3",
          text: this.language("addEditProduct.editStep3Text"),
        },

        stepButton: this.language("addEditProduct.stepButton"),
        uploaderUrl: "admin/merchant/upload/saveProductsBatch",
      },
    };
  },
  methods: {},
  mounted() {},
};
</script>
<style scoped lang="scss">
.box {
  height: 100%;
}
.card {
  margin-bottom: 30px;
}
</style>